var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 57.469,
    viewBox: "0 0 50 57.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856",
    transform: "translate(0 1.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    d: "M16.669,5.243A2.878,2.878,0,0,0,17.99,2.7,2.628,2.628,0,0,0,16.522.374a2.6,2.6,0,0,0-2.838.1l-.979.65h0C10.125,2.833,7.564,4.533,5.023,6.27a2.79,2.79,0,1,0,3.156,4.6C11.017,9.011,13.855,7.127,16.669,5.243ZM35.874.423a2.765,2.765,0,0,0-.147,4.746Q36.974,6,38.215,6.824h0C40.29,8.2,42.358,9.58,44.438,10.944a2.717,2.717,0,0,0,3.792-.734,2.745,2.745,0,0,0-.685-3.89c-2.911-2.006-5.872-3.964-8.832-5.9A2.645,2.645,0,0,0,35.874.423Zm1.64,42.425A1.981,1.981,0,0,1,34.75,42.6l-7.34-7.34q-.378-.378-.757-.762h0c-.508-.514-1.02-1.031-1.543-1.538a2.2,2.2,0,0,1-.661-1.615V18.8a1.972,1.972,0,1,1,3.939,0V30.15a1.337,1.337,0,0,0,.391.93c1.732,1.761,3.481,3.514,5.227,5.262h0q1.747,1.75,3.483,3.5a1.98,1.98,0,0,1,0,3.034Z",
    transform: "translate(-1.581 0)",
    fill: "none",
    stroke: "#2ec1b2",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    transform: "translate(0 6.45)",
    fill: "none",
    stroke: "#2ec1b2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderClock);
export default __webpack_public_path__ + "static/media/reminder_clock.293fcbd9cf5c3e2e16e15b614d2f0889.svg";
export { ForwardRef as ReactComponent };